import {InjectionToken} from '@angular/core';
import {Params} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

export const COMMUNICATION_URL_PARAMS = new InjectionToken<BehaviorSubject<Params>>(
  'COMMUNICATION_URL_PARAMS'
);
